import React, { useState } from "react";

export const InvoiceCard = ({ invoice, onView, onDownload, onPay }) => {
  const statusColors = {
    paid: "bg-green-100 text-green-800",
    pending: "bg-yellow-100 text-yellow-800",
    overdue: "bg-red-100 text-red-800",
    canceled: "bg-gray-100 text-gray-800",
  };

  const statusLabels = {
    paid: "Payée",
    pending: "En attente",
    overdue: "En retard",
    canceled: "Annulée",
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR",
    }).format(amount);
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow duration-300">
      <div className="px-5 py-4 border-b border-gray-200 flex justify-between items-center">
        <div>
          <h3 className="text-sm font-medium text-gray-800">
            Facture {invoice.number}
          </h3>
          <p className="text-xs text-gray-500 mt-1">Émise le {invoice.date}</p>
        </div>
        <span
          className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium shadow-sm ${statusColors[invoice.status]}`}
        >
          {statusLabels[invoice.status]}
        </span>
      </div>

      <div className="p-5">
        <div className="grid grid-cols-2 gap-x-5 gap-y-3">
          <div>
            <p className="text-xs text-gray-500">Montant</p>
            <p className="text-sm font-medium text-gray-800">
              {formatAmount(invoice.amount)}
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Date d'échéance</p>
            <p className="text-sm font-medium text-gray-800">
              {invoice.dueDate}
            </p>
          </div>
          {invoice.periodStart && invoice.periodEnd && (
            <div className="col-span-2">
              <p className="text-xs text-gray-500">Période</p>
              <p className="text-sm font-medium text-gray-800">
                {invoice.periodStart} - {invoice.periodEnd}
              </p>
            </div>
          )}
          {invoice.status === "paid" && invoice.paymentDate && (
            <div className="col-span-2">
              <p className="text-xs text-gray-500">Payée le</p>
              <p className="text-sm font-medium text-gray-800">
                {invoice.paymentDate}
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="bg-gray-50 border-t border-gray-200 px-5 py-4 flex justify-end space-x-3">
        <button
          onClick={() => onView(invoice.id)}
          className="text-blue-600 hover:text-blue-800 text-xs font-medium flex items-center transition-colors duration-200"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
            <path
              fillRule="evenodd"
              d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
              clipRule="evenodd"
            />
          </svg>
          Voir
        </button>
        <button
          onClick={() => onDownload(invoice.id)}
          className="text-green-600 hover:text-green-800 text-xs font-medium flex items-center transition-colors duration-200"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
          Télécharger
        </button>
        {invoice.status === "pending" && onPay && (
          <button
            onClick={() => onPay(invoice.id)}
            className="text-purple-600 hover:text-purple-800 text-xs font-medium flex items-center transition-colors duration-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 mr-1"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                clipRule="evenodd"
              />
            </svg>
            Payer
          </button>
        )}
      </div>
    </div>
  );
};
